<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs v-model:activeKey="activeKey" destroyInactiveTabPane>
        <a-tab-pane :key="1" tab="经销商业务员首页设置" forceRender>
          <homeSet></homeSet>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="经销商业务员常用功能设置">
          <homeUsedSet></homeUsedSet>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref } from "vue";
import homeSet from './components/salesman_page_setup';
import homeUsedSet from './saleUsed/index';
export default {
  components: {homeSet,homeUsedSet },
  setup(props) {
    const activeKey = ref(1)
    return {
      activeKey
    };
  },
};
</script>